import { render, staticRenderFns } from "./spacecraftmap-config.vue?vue&type=template&id=4765e632&"
import script from "./spacecraftmap-config.vue?vue&type=script&lang=ts&"
export * from "./spacecraftmap-config.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports